const STORAGE_KEY = 'whatsapp-expand-closed';

class WhatsappExpand {
    constructor(el) {
        this.DOM = { el: el };
        this.DOM.closeButton = this.DOM.el.querySelector('.whatsapp-expand__close');

        this.init();
        this.initEvents();
    }

    init() {
        if (sessionStorage.getItem(STORAGE_KEY) === '1') {
            this.DOM.el.classList.add('d-none');
        }
    }

    initEvents() {
        if (!this.DOM.closeButton) {
            return;
        }

        this.DOM.closeButton.addEventListener('click', (e) => {
            e.preventDefault();

            this.DOM.el.classList.add('d-none');
            sessionStorage.setItem(STORAGE_KEY, '1');
        });
    }
}

const nodes = Array.from(document.querySelectorAll('[data-whatsapp-expand]'));
nodes.forEach((node) => { new WhatsappExpand(node); });
